import { DateBox } from "devextreme-react";
import { RequiredRule } from "devextreme-react/form";
import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hasPermission } from "../../../../../utils/hasPermission";
import { PERM } from "../../../../../utils/permissions";
import {
  updateWorkEndYearMonth,
  updateWorkStartYearMonth,
} from "../Redux/payment";

export default function TwoDateBoxComponent(props) {
  const { firstDateBox, secondDateBox } = props;

  const dispatch = useDispatch();

  const userInfo = useSelector((state) => state.userInfo);
  const canEditSales = hasPermission(userInfo.permissions, PERM.SALES_MGMT_EDIT);

  // const firstDateBoxRef = u/seRef(null);

  const onFirstValueChanged = (e) => {
    if (e.value) {
      dispatch(
        updateWorkStartYearMonth({
          workStartYearMonth: e.value,
        })
      );
    }
  };

  const onSecondValueChanged = (e) => {
    if (e.value) {
      dispatch(
        updateWorkEndYearMonth({
          workEndYearMonth: e.value,
        })
      );
    }
  };

  return (
    <React.Fragment>
      <DateBox
        // ref={firstDateBoxRef}
        ref={firstDateBox.ref}
        // placeholder={firs\tDateBox ? firstDateBox.placeholder : ``}
        style={{
          float: "left",
          width: "45%",
          marginRight: "3px",
        }}
        // displayFormat="yyyy-MM-dd"
        // dateSerializationFormat="yyyy-MM-dd"
        displayFormat="yyyy-MM"
        dateSerializationFormat="yyyy-MM"
        // showClearButton={true}
        max={firstDateBox ? firstDateBox.max : null}
        value={firstDateBox ? firstDateBox.value : null}
        calendarOptions={{
          maxZoomLevel: "year",
          minZoomLevel: "decade",
          zoomLevel: "year",
        }}
        useMaskBehavior={true}
        readOnly={canEditSales ? true : false}
        onValueChanged={onFirstValueChanged}
      ></DateBox>
      <span style={{ float: "left", marginTop: "7px" }}>~</span>
      <DateBox
        ref={secondDateBox.ref}
        // placeholder={secondDateBox ? secondDateBox.placeholder : ``}
        style={{
          float: "left",
          width: "45%",
        }}
        // displayFormat="yyyy-MM-dd"
        // dateSerializationFormat="yyyy-MM-dd"
        displayFormat="yyyy-MM"
        dateSerializationFormat="yyyy-MM"
        // showClearButton={true}
        // min={
        //   firstDateBoxRef.current
        //     ? firstDateBoxRef.current.instance.option("value")
        //     : null
        // }
        min={
          firstDateBox.ref.current
            ? firstDateBox.ref.current.instance.option("value")
            : null
        }
        max={secondDateBox ? secondDateBox.max : null}
        value={secondDateBox ? secondDateBox.value : null}
        calendarOptions={{
          maxZoomLevel: "year",
          minZoomLevel: "decade",
          zoomLevel: "year",
        }}
        useMaskBehavior={true}
        readOnly={canEditSales ? true : false}
        onValueChanged={onSecondValueChanged}
      ></DateBox>
    </React.Fragment>
  );
}
